import React, { useReducer, useContext } from "react";
import { Stepper, StepLabel, Step } from "@mui/material";
// import BookDetails from "./ProgramDetails";
import ProgramDetails from "./ProgramDetails";
// import BookContent from "./BookContent";
// import BookPricing from "./BookPricing";
import { AddApplicationContext } from "../../context/AddApplicationContext";
import Education from "./Education";
import Contacts from "./Contacts";
import Submission from "./Submission";

export default function AddApplication() {
  const { currentStep } = useContext(AddApplicationContext);

  const showStep = (currentStep) => {
    switch (currentStep) {
      case 1:
        return <ProgramDetails />;
      case 2:
        return <Education />;
      case 3:
        return <Contacts />;
      case 4:
        return <Submission />;
      default:
        break;
    }
  };

  return (
    <div
      style={{
        minHeight: "80vh",
        width: "100%",
        // zIndex: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        background: "rgb(232, 232, 232)",
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 50,
        backgroundColor: "#f0f0f0",
        borderRadius: 8,
        boxSizing: "border-box",
      }}
    >
      <div
        className="stepperWrapper"
        // style={{
        //   width: "70%",
        //   flexDirection: "column",
        //   justifyContent: "flex-start",
        //   alignItems: "space-between",
        //   gap: 10,
        //   backgroundColor: "transparent",
        //   paddingBottom: 20,
        // }}
      >
        <Stepper
          orientation="horizontal"
          activeStep={currentStep - 1}
          style={{ width: "100%" }}
        >
          <Step>
            <StepLabel>Program Details</StepLabel>
          </Step>
          <Step>
            <StepLabel>Education</StepLabel>
          </Step>

          <Step>
            <StepLabel>Contacts</StepLabel>
          </Step>
          {/* <Step>
            <StepLabel>Extra Information</StepLabel>
          </Step> */}
          <Step>
            <StepLabel>Submission</StepLabel>
          </Step>
        </Stepper>
      </div>
      {showStep(currentStep)}
    </div>
  );
}
